const SUPPORTED_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:']
const BARE_DOMAIN = /^[\w-]+(\.[\w-]+)+(\/\S*)?$/

export const sanitizeUrl = (value: string): string | null => {
  const url = value.trim()
  if (!url) return null

  try {
    const parsed = new URL(url)
    return SUPPORTED_PROTOCOLS.includes(parsed.protocol) ? parsed.toString() : null
  } catch {
    return BARE_DOMAIN.test(url) ? `https://${url}` : null
  }
}

export const validateUrl = (url: string): boolean => sanitizeUrl(url) !== null
